<template>
    <article>
        <p>
            Coroot requires a database to store its configuration, such as projects and Prometheus connection details.
        </p>

        <h2>SQLite (default)</h2>

        <p>
            By default, Coroot uses an embedded <var>sqlite</var> database.
            For production installations, we recommend users to use a robust database, such as Postgres.
            This allows you to run several Coroot replicas for high availability and to backup the database.
        </p>

        <h2>Postgres</h2>

        <p>
            Create <var>role</var> and <var>database</var>:
        </p>

        <pre v-hl.sql>
CREATE ROLE coroot WITH LOGIN PASSWORD '&lt;password&gt;';
CREATE DATABASE coroot WITH OWNER = coroot;
        </pre>

        <p>
            You can configure Coroot to use Postgres by setting the <var>--pg-connection-string</var> command line argument or the <var>PG_CONNECTION_STRING</var> environment variable:
        </p>
        <pre v-hl.sh>
docker run -d --name coroot \
  -p 8080:8080 \
  -e PG_CONNECTION_STRING="postgres://coroot:&lt;password&gt;@127.0.0.1:5432/coroot?sslmode=disable" \
  ghcr.io/coroot/coroot
        </pre>

        <p>Here is an example of how to format the <var>PG_CONNECTION_STRING</var> variable using a Kubernetes secret:</p>
        <pre v-hl.yaml>
...
env:
- name: PGPASSWORD
  valueFrom: { secretKeyRef: { name: coroot.pg.credentials, key: password } }
- name: PG_CONNECTION_STRING
  value: "host=coroot-db user=coroot password=$(PGPASSWORD) dbname=coroot sslmode=require connect_timeout=1"
...
        </pre>

        <p>
            To learn more about the connection string format follow the
            <a href="https://www.postgresql.org/docs/current/libpq-connect.html#LIBPQ-CONNSTRING" target="_blank">Postgres documentation</a>.
        </p>

    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
